"use client";

import { c as _c } from "react/compiler-runtime";
import Script from "next/script";
import { useEffect, useRef } from "react";
import { useTracking } from "@/hooks/tracking/use-tracking";
import { enqueueWhenReady, isReady, markReady } from "@/utilities/queue/action-queue";
const gemiusHitcollector = "gadk.hit.gemius.pl";
const gemiusScriptUrl = `https://${gemiusHitcollector}/xgemius.js`;
type GemiusProps = {
  readonly gemiusId: string;
};
export function GemiusTracker(t0) {
  const $ = _c(10);
  const {
    gemiusId
  } = t0;
  const {
    subscribe
  } = useTracking();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = isReady("gemius");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const isFirstHit = useRef(!t1);
  let t2;
  let t3;
  if ($[1] !== gemiusId || $[2] !== subscribe) {
    t2 = () => subscribe("page-view", () => {
      if (isFirstHit.current) {
        isFirstHit.current = false;
        return;
      }
      enqueueWhenReady("gemius", () => {
        if (typeof window.pp_gemius_hit === "function") {
          window.pp_gemius_hit(gemiusId);
        }
      });
    });
    t3 = [subscribe, gemiusId];
    $[1] = gemiusId;
    $[2] = subscribe;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  const handleLoad = _temp;
  const t4 = `
          window.pp_gemius_identifier = "${gemiusId}";
          window.pp_gemius_hitcollector = "${gemiusHitcollector}";
          window.pp_gemius_use_cmp = true;
          window.pp_gemius_cmp_timeout = Infinity;
        `;
  let t5;
  if ($[5] !== t4) {
    t5 = <Script id="gemius-config" strategy="afterInteractive">{t4}</Script>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Script onLoad={handleLoad} src={gemiusScriptUrl} strategy="afterInteractive" />;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t5) {
    t7 = <>{t5}{t6}</>;
    $[8] = t5;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  return t7;
}
function _temp() {
  markReady("gemius");
}